import React, { type CSSProperties } from 'react';
import './MBTIBigLetter.css';

interface MBTIBigLetterProps {
  letter: string;
  glowColor: string;
}

const MBTIBigLetter: React.FC<MBTIBigLetterProps> = ({ letter, glowColor }) => {
  const style = { '--mbti-glow-color': glowColor } as CSSProperties;
  return (
    <span className="mbti-big-letter" style={style}>
      {letter}
    </span>
  );
};

export default MBTIBigLetter;
